
$(document).ready(function() {

  $('.close-modal,.tnx-modal__close').on('click',function(){
    $('.modal,.overlay').fadeOut();
  });
  $('.mobile-menu__item--sub').on('click',function(){
    $(this).toggleClass('active');
  });
  $('.farmer-login,.vacancy-order').on('click',function(e){
    e.preventDefault();
    $('.farmer-modal,.overlay').fadeIn();
  });

  $(document).mouseup(function (e){ // событие клика по веб-документу
    var div = $(".weather-city"); // тут указываем ID элемента
    if (!div.is(e.target) // если клик был не по нашему блоку
        && div.has(e.target).length === 0) { // и не по его дочерним элементам
      div.removeClass('active'); // скрываем его
    }
  });
  
  $(document).mouseup(function (e){ // событие клика по веб-документу
    var div = $(".modal"); // тут указываем ID элемента
    if (!div.is(e.target) // если клик был не по нашему блоку
        && div.has(e.target).length === 0) { // и не по его дочерним элементам
      div.fadeOut(); // скрываем его
      $('.overlay').fadeOut(); // скрываем его
    }
  });

  $('.burger').on('click',function(){
    $(this).toggleClass('active')
    $('.mobile-modal').toggleClass('active');
  });
  $('.orderModal-btn').on('click',function(e){
    e.preventDefault();
    $('.recall-modal,.overlay').fadeIn();
  });
  $('.recall-btn').on('click',function(e){
    e.preventDefault();
    $('.recall-modal1,.overlay').fadeIn();
  });
  $('.weather-city span').on('click' , function() {
    $('.weather-city').toggleClass('active');
  });

  $('.weather-city__list__item').on('click',function(){
    var cityName = $(this).text();
    $('.weather-city span').text(cityName);
  });

  $('.middle-header__city').on('click',function(){
    $('.middle-header__city__sub').slideToggle();
  });


  $('.middle-header__tabs__item').each( function(ind,el) {
    $(this).attr('data-tab',ind);
  });
  $('.middle-header__content__item').each( function(ind,el) {
    $(this).attr('data-tab',ind);
  });

  $('.middle-header__tabs__item').on('click',function(){
    $('.middle-header__tabs__item').removeClass('active');
    $(this).addClass('active');
    var dataTab = $(this).data('tab');
    $('.middle-header__content__item').removeClass('active');
    $('.middle-header__content__item[data-tab=' + dataTab + ']').addClass('active');
  });

  $('.middle-header__city__sub__item').on('click',function(){
    var cityName = $(this).text();
    $('.middle-header__city').text(cityName);
    $('.middle-header__city__sub').slideUp();
  });

  $('.lang-item').on('click',function(){
    $('.lang-item').removeClass('active');
    $(this).addClass('active');
  });

  $('.options-column__top').on('click',function(){
    $('.options-column').toggleClass('hide');
    $(this).parent().toggleClass('active');
    $(this).parent().removeClass('hide');
    $(this).closest('.options-column').find('.options-content').fadeToggle();
  });

  var swiper = new Swiper('.swiper-container', {
    slidesPerView: 3,
    spaceBetween: 10,
    loop: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    }
  });

  $('.vacancy-btn').on('click',function(){
    $(this).toggleClass('active');
    $(this).closest('.vacancy-item').find('.vacancy-item__content').slideToggle();
  });

  $('.manual-more').on('click',function(e){
    e.preventDefault();
    $(this).closest('.manual-info').find('.manual-hidden').slideToggle();
    $(this).toggleClass('active');
  });

});